const getQueryParamByName = (
  name: string,
  url: string = window.location.href
): string | null => {
  // eslint-disable-next-line
  const param = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(
    encodeURIComponent(results[2].replace(/\+/g, ' '))
  ).replace(/%20/g, ' ');
};

export default getQueryParamByName;
